<template>
  <div class="container">
    <div>
      <h1>404</h1>
      <h2>{{ $language.notFound.tips }}</h2>
      <!-- <p>Not the correct URL。</p> -->
      <el-button type="primary" @click="goToPage">{{
        $language.notFound.goToPage
      }}</el-button>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    goToPage() {
      this.$router.push({ path: "/home/qrder/query" });
    },
  },
};
</script>
<style  scoped>
.container {
  padding-top: 20%;
  box-sizing: border-box;
  height: 100vh;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
}
h1 {
  font-size: 100px;
  margin: 15px 0px;
  font-weight: bold;
}
p {
  width: 100%;
  margin-top: 10px;
}
button {
  margin-top: 20px;
}
</style>